<template>
  <el-dialog
    :visible.sync="authorizationListVisible"
    :show-close="false"
    width="80%" @open="needRefresh()">
    <pea-authorization ref="peaAuthorization" :peaId="this.peaId"></pea-authorization>
    <br />
    <el-button type="primary" @click="close()">Close</el-button>
  </el-dialog>
</template>

<script>
// eslint-disable-next-line
import store from '../../state/store.js'
export default {
  name: 'authorization-list-popup',
  props: {
    peaId:
    {
      default: 0
    }
  },
  data () {
    return {
      authorizationListVisible: false
    }
  },
  methods: {
    showAuthorizationListPopup () {
      this.authorizationListVisible = true
    },
    close () {
      this.authorizationListVisible = false
    },
    needRefresh () {
      this.$refs.peaAuthorization.fetchData()
    }
  }
}

</script>
<style scoped>

</style>
